import { mapGetters } from "vuex";

import {
  MONITOR_GET_TAGS,
  MONITOR_GET_CONSUMER_INSIGHTS,
  MONITOR_GET_CONSUMER_GENERATIONS,
  MONITOR_GET_MARKET_INSIGHTS,
  MONITOR_GET_MARKET_SECTORS,
  MONITOR_GET_GEOLOCALIZATION,
  MONITOR_GET_GENDER
} from "@/store/actions.type";

export const monitorsDataMixin = {
  computed: {
    ...mapGetters(["monitorTags", "monitorConsumerInsights", "monitorConsumerGenerations", "monitorMarketInsights", "monitorMarketSectors", "monitorGeolocalization", "monitorGender"]),
    monitorConsumerInsightsOptions: function() {
      let optionsArray = [];
      for (let i = 0; i < this.monitorConsumerInsights.length; i++) {
        let singleTag = {
          text: this.monitorConsumerInsights[i].insight,
          value: this.monitorConsumerInsights[i].id
        }
        optionsArray.push(singleTag);
      }
      return optionsArray
    },
    monitorMarketInsightsOptions: function() {
      let optionsArray = [];
      for (let i = 0; i < this.monitorMarketInsights.length; i++) {
        let singleTag = {
          text: this.monitorMarketInsights[i].insight,
          value: this.monitorMarketInsights[i].id
        }
        optionsArray.push(singleTag);
      }
      return optionsArray
    },
    monitorConsumerGenerationsOptions: function() {
      let optionsArray = [];
      for (let i = 0; i < this.monitorConsumerGenerations.length; i++) {
        let singleTag = {
          text: this.monitorConsumerGenerations[i].generation,
          value: this.monitorConsumerGenerations[i].id
        }
        optionsArray.push(singleTag);
      }
      return optionsArray
    },
    monitorGeolocalizationOptions: function() {
      let optionsArray = [];
      for (let i = 0; i < this.monitorGeolocalization.length; i++) {
        let singleTag = {
          text: this.monitorGeolocalization[i].geolocalizations,
          value: this.monitorGeolocalization[i].id
        }
        optionsArray.push(singleTag);
      }
      return optionsArray
    },
    monitorGenderOptions: function() {
      let optionsArray = [];
      for (let i = 0; i < this.monitorGender.length; i++) {
        let singleTag = {
          text: this.monitorGender[i].gender,
          value: this.monitorGender[i].id
        }
        optionsArray.push(singleTag);
      }
      return optionsArray
    }
  },
  methods: {
    getMonitorsData() {
      if(this.monitorTags.length == 0) {
        this.$store.dispatch(MONITOR_GET_TAGS);
      }
      if(this.monitorConsumerInsights.length == 0) {
        this.$store.dispatch(MONITOR_GET_CONSUMER_INSIGHTS);
      }
      if(this.monitorConsumerGenerations.length == 0) {
        this.$store.dispatch(MONITOR_GET_CONSUMER_GENERATIONS);
      }
      if(this.monitorMarketInsights.length == 0) {
        this.$store.dispatch(MONITOR_GET_MARKET_INSIGHTS);
      }
      if(this.monitorMarketSectors.length == 0) {
        this.$store.dispatch(MONITOR_GET_MARKET_SECTORS);
      }
      if(this.monitorGeolocalization.length == 0) {
        this.$store.dispatch(MONITOR_GET_GEOLOCALIZATION);
      }
      if(this.monitorGender.length == 0) {
        this.$store.dispatch(MONITOR_GET_GENDER);
      }
    }
  }
}